<template>
  <div class="message-container">
    <!-- TITLE 标题 -->
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <!-- 搜索表单 -->
    <ots-refer :selectList="selectList" :request-form="selectForm" @search="getResult"/>
    <!-- 表格 -->
    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableOption="tableOption"
      :tableData="tableData"
      :batchOperBtn="batchOperBtn"
      :pagination="pagination"
      @changeNum="changeSize"
      @changePage="changePage"
      @handleSelectionChange="bachOper"
    ></ots-table-group-new>
    <!-- 短信督导弹窗 -->
    <ots-custom-dialog :dialog.sync="sendDialog" title="短信督导" width="40%">
      <template v-slot:content>
        <div class="export-setting">
          <div>本次将为<span class="col_red">{{studentNum}}</span>位学生发送短信</div>
          <div class="mt10">
            <el-input type="textarea" v-model="content" :rows="4"/>
          </div>
          <div class="mt20 col_grayQ">
            <p>提示：</p>
            <p class="mt10"> 1、<span class="col_red mr5">{学生姓名}</span>系统动态获取学生的姓名显示！不需要可删除。</p>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="sendDialog = false">取消</el-button>
        <el-button round type="primary" @click="messagePushFn">确定</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import { getSelectCourse } from '@/http/modules/baseSet/course'
import { getMessageList, sentMessageFn } from '@/http/modules/applySet/message'
import { getSinglePlan } from '@/http/modules/examSet/examBatch'

export default {
  name: 'messagePush',
  data () {
    return {
      sendDialog: false,
      mainTopBtnList: [],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "审核状态",
          type: "select",
          requestKey: "multiple_state",
          label: "key",
          value: "value",
          multiple: true,
          data: [],
        },
        {
          title: "缴费状态",
          type: "select",
          requestKey: "multiple_payState",
          label: "key",
          value: "value",
          multiple: true,
          data: [
            { key: "全部", value: '' },
            { key: "已缴费", value: "1" },
            { key: "未缴费", value: "0" },
          ],
        },
        {
          title: "报考课程",
          type: "select",
          requestKey: "courseId",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" }
          ],
        },
        {
          title: '函授站',
          type: 'select',
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
          ],
        },
        {
          title: "证件号",
          type: "input",
          requestKey: "cardNo",
          placeholder: "请输入",
        },
        {
          title: "姓名",
          type: "input",
          requestKey: "realName",
          placeholder: "请输入",
        },
        {
          title: "手机号",
          type: "input",
          requestKey: "phone",
          placeholder: "请输入",
        },
        {
          title: "成绩",
          type: "select",
          requestKey: "scoreState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "合格" },
            { id: 2, name: "不合格" },
          ],
        }
      ],
      selectForm: {
        multiple_payState: [''],
        multiple_state: [''],
        state: '',
        payState: '',
        planId: null,
        courseId: '',
        scoreState: '',
        stationId: '',
        realName: "",
        orders: "",
        cardNo: "",
        page: 1,
        size: 10,
      },
      tempSelecForm: {
        state: '1',
        payState: '0',
        planId: null,
        courseId: '',
        stationId: '',
        realName: "",
        orders: "",
        cardNo: "",
      },
      content: `{学生姓名}您好，`,
      tableHeader: [
        {
          title: '函授站',
          prop: 'stationName'
        },
        {
          title: "姓名",
          prop: "realName",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "手机号",
          prop: "phone",
        },
        {
          title: "报考课程",
          prop: "courseName",
          width: "160"
        },
        {
          title: "成绩",
          prop: "score",
        },
        {
          title: "审核状态",
          prop: "auditState",
        },
        {
          title: "审核不通过原因",
          prop: "reason",
        },
        {
          title: "缴费状态",
          prop: "payState",
          type: 'tag_Z',
          tagColor: (scope) => {
            const options = {
              '已缴费': 'col_green',
              '未缴费': 'col_grayQ'
            }
            return options[scope.row.payState]
          },
        },
      ],
      tableOption: {
        multiple: true,
      },
      multipleSelectList: [],
      tableData: [],
      batchOperBtn: [
        {
          title: "短信督导",
          icon: "iconfont icon-duanxindudao",
          click: this.openMessageDialog
        },
      ],
      pagination: {
        total: 0,
      },
    }
  },
  computed: {
    studentNum () {
      if (this.multipleSelectList.length) {
        return this.multipleSelectList.length
      }
      return this.pagination.total
    }
  },
  watch: {
    'selectForm.multiple_state': {
      handler (val) {
        this.selectForm.state = val.join()
      },
      immediate: true
    },
    'selectForm.multiple_payState':{
      handler (val) {
        this.selectForm.payState = val.join()
      },
      immediate: true
    },
    'selectForm.planId': {
      handler (val) {
        this.getResult()
      }
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    getResult() {
      this.selectForm.page = 1
      this.getTableList()
    },
    openMessageDialog() {
      if (this.studentNum) {
        this.sendDialog = true
      } else {
        this.$message.warning('请选择学生范围发送短信。')
      }
    },

    initData() {
      this.mixin_getSelectPlan().then((data) => {
        if (data) {
          this.$set(this.selectList[0], "data", data);
          this.selectForm.planId = data[0].id;
        }
      });
      this.mixin_getSelectStation().then((data) => {
        let newStationList = [
          { id: "", name: "全部" },
          ...data
        ]
        this.$set(this.selectList[4], 'data', newStationList)
      });
      getSelectCourse().then(res=>{
        let courseList = [
          { id: "", name: "全部" },
          ...res.data
        ]
        this.$set(this.selectList[3], 'data', courseList)
      })
    },
    dealParamsWithArray(obj) {
      let params = { ...obj }
      for (let item in params) {
        if (Array.isArray(params[item])) {
          delete params[item]
        }
      }
      return params
    },

    getTableList() {
        getSinglePlan({planId : this.selectForm.planId}).then(res=>{
          if(res.data.needAudit == 1) {
            let dataList = [
              { value: "", key: "全部" },
              { value: "3", key: "待终审" },
              { value: "4", key: "终审通过" },
              { value: "5", key: "终审不通过" }
            ]
            this.$set(this.selectList[1], 'data', dataList)
          } else if(res.data.needAudit == 2){
            let dataList = [
              { value: "", key: "全部" },
              { value: "1", key: "待初审" },
              { value: "2", key: "初审不通过" },
              { value: "3", key: "待终审" },
              { value: "4", key: "终审通过" },
              { value: "5", key: "终审不通过" }
            ]
            this.$set(this.selectList[1], 'data', dataList)
          } else {
            let dataList = [
              { value : "", key: "全部" },
              { value: "4", key: "审核通过" },
              { value: "6", key: "审核不通过" }
            ]
            this.$set(this.selectList[1], 'data', dataList)
          }

          if (this.$store.state.IsHavePayPlan == 1) {
            this.tableHeader.map( (e, i) => {
              if (e.prop == 'payState') {
                this.tableHeader.splice(i, 1);
              }
            })
            this.selectList.map( (item, index) => {
              if (item.requestKey == "multiple_payState") {
                this.selectList.splice(index, 1);
              }
            })
          }

          let params = {...this.selectForm};
          params.state = params.multiple_state.join();
          for (let item in params) {
            if (Array.isArray(params[item])){
              delete params[item]
            }
          }

          return getMessageList(params)
        }).then( ({data}) => {
          this.tableData = data.records
          this.pagination.total = data.total
          this.tempSelecForm = this.dealParamsWithArray(this.selectForm)
        })
    },

    messagePushFn() {
      if (!this.pagination.total) {
        return
      }
      if (!this.content) {
        this.$message.warning('请填写短信内容')
        return
      }
      const { page, size, ...params} = this.tempSelecForm
      if (this.multipleSelectList.length) {
        params.ids = this.multipleSelectList.join()
      }
      params.content = this.content
      this.$confirm(`请再次确认是否发送${this.studentNum}条短信？`, '提示', {
        type: 'warning'
      }).then(() => {
        return sentMessageFn(params)
      }).then(({ code }) => {
        if (code == 1) {
          this.$message.success('发送成功。')
          this.content = `{学生姓名}您好，`
          this.sendDialog = false
        }
      })
    },

    bachOper(res) {
      this.multipleSelectList = res.map((item) => {
        return item.planStudentId;
      });
    },

    changeSize(num) {
      this.selectForm.size = num;
      this.getTableList();
    },
    
    changePage(p) {
      this.selectForm.page = p;
      this.getTableList();
    },
  }
}
</script>

<style>
.mainCon {
  margin-top: 16px;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
}
</style>